var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"status-module":"elasticSearch","extra-info":_vm.extraInfo,"resource":"elasticsearchs","base-info":_vm.baseInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }